import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import ViewSignups from "../EditEvent/ViewSignups";

export const ViewEventSignupsModal = (props) => {
  const { isOpen, setIsOpen, currentSignups } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      size={"2xl"}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>View Signups</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <ViewSignups
            onDone={() => setIsOpen(false)}
            currentSignups={currentSignups}
          />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};
